import React, { Component } from "react";
import { Grid, List, ListItem, Icon, ListItemIcon, Box } from '@material-ui/core';
import Fab from "@material-ui/core/Fab/Fab";
import Button from "@material-ui/core/Button/Button";
import Hidden from "@material-ui/core/Hidden/Hidden";
import Header from "../../components/Header";
import EditProfile from "../../components/ChefProfile/EditProfile";
import PaymentInfo from "../../components/ChefProfile/paymentInfo.js";
import CancellationPolicy from "../../components/ChefProfile/CencellationPolicy";
import style from '../../components/Header/style';
import Transactions from '../../components/Transactions';
//import InviteFriend from "../../components/ChefProfile/inviteFriend";
import BecomeVerified from "../../components/ChefProfile/BecomeVerified";
import GetHelp from "../../components/ChefProfile/getHelp";
import Feedback from "../../components/ChefProfile/Feedback";
import styles from "./style";
import { connect } from "react-redux";
import { getUser, getPaymentInfo } from "../../redux/user";
import { getChef } from "../../redux/user";
import MyKitchen from "../../components/ChefProfile/MyKitchen";
import ChefPaymentInfo from "../../components/ChefProfile/ChefPaymentInfo";
import SubscriptionPage from "../../components/ChefProfile/Subscription";
import MenuList from "@material-ui/core/MenuList";
import Breadcrumbs from "../../components/Breadcrumbs";
import {setReturnUrl} from "../../redux/auth";

class UserProfile extends Component {

  constructor(props) {
    super(props);

    this.state = {
      step: "",
      steps: [
        {
          header: "edit-profile",
          text: "Edit profile",
          id: 1
        },
        {
          header: "my-kitchen",
          text: "My kitchen",
          id: 2
        },
        {
          header: "payment-info",
          text: "Payment info.",
          id: 3
        },
        {
          header: "chef-payment-info",
          text: "Payment info.",
          id: 4
        },
        {
          header: "become-verified-chef",
          text: "Become a verified chef",
          id: 9
        },
        {
          header: "verified-chef",
          text: "Verified chef",
          id: 10
        },
        {
          header: "accounting",
          text: "Accounting",
          id: 8
        },
        /*{
          header: "invite-friends",
          text: "Invite friends step",
          id: 5
        },*/
        /*{
          header: "get-help",
          text: "Get help",
          id: 6
        },*/
        {
          header: "feedback",
          text: "Reach us",
          id: 7
        }
      ],
      userId: null,
      IsChef: false,
      userDetails: "",
      dinerSteps: [1, 2, 3, 5, 7],
      chefSteps: [1, 4, 3, 5, 7, 8],
      bookingId: null
    };
  }

  componentDidMount() {
    let pathName = this.props.history.location.pathname;
    const { userId, dispatch } = this.props;

    let loggedInUserId = null;
    if (window && window.localStorage.hasOwnProperty("zg-cc-auth-userId")) {
      loggedInUserId = window.localStorage.getItem("zg-cc-auth-userId");
    }

    if (!loggedInUserId) {
      dispatch(setReturnUrl(pathName));
      this.props.history.push('/sign-in', { returnUrl: pathName });
    } else {
      dispatch(getUser(userId));
      dispatch(getChef(userId));
      dispatch(getPaymentInfo(userId));
      this.setState({ step: pathName });
      this.props.history.push(pathName);
      if (this.props.match) {
        if (this.props.match.params) {
          if (this.props.match.params.type && this.props.match.params.booking) {
            this.setState({bookingId: this.props.match.params.booking });
          } //end-if params.type && params.booking
        } //end-if match.params
      } // end-if match
    }
  }

  handleClick = step => {
    const { userId, dispatch ,isChef,} = this.props;

    if(isChef)
    dispatch(getChef(userId));
    else
      dispatch(getUser(userId));

    let url = `/home/profile/${step}`;
    this.props.history.push(url);
    this.setState({ step: url });
    window.onload = function() {
      window.scrollTo(0, 0);
    };
  };

  render() {
    let { step, steps, dinerSteps, chefSteps } = this.state;
    const { chef, isChef, setupStep } = this.props;
    let displaySteps = isChef ? chefSteps : dinerSteps;
    const showVerifyLink = !!setupStep && setupStep > 7 ? true : false;

    steps = steps.filter((value, index, arr) => {
      return displaySteps.indexOf(value.id) != -1;
    });
    const pathname = this.props.location && this.props.location.pathname ? this.props.location.pathname.substr(1) : '';
    const childRoutes = [
      {
        display: 'Profile',
        link: 'home/profile/edit-profile'
      },
    ];
    if (pathname !== 'home/profile/edit-profile') {
      switch (pathname) {
        case 'home/profile/my-kitchen':
          childRoutes.push({
            display: 'My Kitchen',
            link: 'home/profile/my-kitchen'
          });
          break;

        case 'home/profile/payment-info':
          childRoutes.push({
            display: 'Payment Info.',
            link: 'home/profile/payment-info'
          });
          break;

        case 'home/profile/chef-payment-info':
          childRoutes.push({
            display: 'Payout Info.',
            link: 'home/profile/chef-payment-info'
          });
          break;

        case 'home/profile/become-verified-chef':
          childRoutes.push({
            display: 'Become Verified Chef',
            link: 'home/profile/become-verified-chef'
          });
          break;

        case 'home/profile/feedback':
          childRoutes.push({
            display: 'Reach Us',
            link: 'home/profile/feedback'
          });
          break;

        case 'home/profile/accounting':
          childRoutes.push({
            display: 'Accounting',
            link: 'home/profile/accounting'
          });
          break;

        case 'home/profile/cancelation-policy':
          childRoutes.push({
            display: 'Cancelation Policy',
            link: 'home/profile/cancelation-policy'
          });
          break;

        case 'home/profile/subscription':
          childRoutes.push({
            display: 'Subscription',
            link: 'home/profile/subscription'
          });
          break;

        default:
          break;
      }
    }

    return (
      <div>

        <Header history={this.props.history}/>
        <Grid
          className="edit-profile-container"
          container
        >
          <Grid item md={12} style={{ textAlign: "right", paddingRight: '0', width: '100%', display: 'flex' }}>
            <Grid className="ipad-set-padding" item xs={12} style={{ marginBottom: 30, paddingLeft: 5}}>
              <Breadcrumbs childRoutes={childRoutes} />
            </Grid>
              <Hidden lgUp>
                {!isChef && (
                  <Button
                    component={"button"}
                    color={"primary"}
                    variant={"outlined"}
                    onClick={() => this.props.history.push('/home/become-chef')}
                    style={styles.becomeChefButtonTab}
                  >
                    Become a chef
                  </Button>
                )}
              </Hidden>
              <Hidden mdDown>
                {!isChef && (
                  <Button
                    component={"button"}
                    color={"primary"}
                    variant={"outlined"}
                    onClick={() => this.props.history.push('/home/become-chef')}
                    style={styles.becomeChefButton}
                  >
                    Become a chef
                  </Button>
                )}
              </Hidden>
            </Grid>
          <Hidden only="xs">
            <Box className="profile-left-col">
              <List>
                {steps.map(item => (
                  <ListItem
                    key={item.header}
                    button
                    onClick={() => this.handleClick(item.header)}
                    onChange={() => this.handleClick(item.header)}
                    style={{
                      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                      justifyContent: 'flex-start',
                      padding: 0
                    }}
                    divider
                  >
                    <div>
                      <p
                        style={
                          step.split("/")[2] == item.header
                            ? styles.stepText
                            : styles.stepSelected
                        }
                      >
                        {item.id === 4 ? (isChef ? 'Payout info.' : item.text) : item.text}
                        {item.id === 4 && !!chef && !chef.payoutInfoExists && !chef.payoutMethod ? <Icon style={{
                          color: 'red',
                          fontSize: 28,
                          marginLeft: 10
                        }}>
                          error
                        </Icon> : null }
                      </p>
                    </div>
                  </ListItem>
                ))}

                {(chef && chef.verified && showVerifyLink) ? (
                    <ListItem
                      style={{
                        padding: 0
                      }}
                      divider
                    >
                      <div>
                        <p
                            style={styles.stepSelected}
                        >
                          You are a verified chef
                        </p>
                      </div>
                    </ListItem>
                ) : isChef && showVerifyLink && (
                    <ListItem
                        button
                        onClick={() => this.handleClick('become-verified-chef')}
                        onChange={() => this.handleClick('become-verified-chef')}
                        style={{
                          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                          justifyContent: 'flex-start',
                          padding: 0
                        }}
                        divider
                    >
                      <div>
                        <p
                            style={
                              step.split("/")[2] == 'become-verified-chef'
                                  ? styles.stepText
                                  : styles.stepSelected
                            }
                        >
                          Become a verified chef
                        </p>
                      </div>
                    </ListItem>
                )}

                {isChef && (
                  <ListItem
                    button
                    onClick={() => this.handleClick('cancelation-policy')}
                    onChange={() => this.handleClick('cancelation-policy')}
                    style={{
                      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                      justifyContent: 'flex-start',
                      padding: 0
                    }}
                    divider
                  >
                    <div>
                      <p
                        style={
                          step.split("/")[2] == 'cancelation-policy'
                            ? styles.stepText
                            : styles.stepSelected
                        }
                      >
                        Cancelation policy
                      </p>
                    </div>
                  </ListItem>
                )}
                {isChef && (
                  <ListItem
                    button
                    onClick={() => this.handleClick('subscription')}
                    onChange={() => this.handleClick('subscription')}
                    style={{
                      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                      justifyContent: 'flex-start',
                      padding: 0
                    }}
                    divider
                  >
                    <div>
                      <p
                        style={
                          step.split("/")[2] == 'subscription'
                            ? styles.stepText
                            : styles.stepSelected
                        }
                      >
                        Subscription
                      </p>
                    </div>
                  </ListItem>
                )}
              </List>
            </Box>
          </Hidden>
          <Box className="profile-right-col">
            {(step === "/home/profile/edit-profile" || step === "/profile/verified-chef") && (
              <EditProfile {...this.props}  onImageRefresh={()=>{}}/>
            )}
            {step === "/home/profile/payment-info" && <PaymentInfo />}
            {step === "/home/profile/chef-payment-info" && <ChefPaymentInfo />}
            {step === "/home/profile/my-kitchen" && <MyKitchen />}
           {/* {step === "/home/profile/invite-friends" && <InviteFriend />}*/}
            {step === "/home/profile/become-verified-chef" && <BecomeVerified history={this.props.history} />}
            {step.startsWith("/home/profile/booking") && <Feedback booking={this.state.bookingId} />}
            {step === "/home/profile/feedback" && <Feedback />}
            {step === "/home/profile/accounting" && <Transactions />}
            {step === "/home/profile/cancelation-policy" && <CancellationPolicy />}
            {step === "/home/profile/subscription" && <SubscriptionPage />}
          </Box>

        </Grid>
      </div>
    );
  }
}

const mapSateToProps = state => {
  return {
    diner: state.user.diner,
    chef: state.user.chef,
    userId: state.auth.userId,
    paymentInfo: state.user.paymentInfo,
    isChef: state.auth.isChef,
    setupStep: state.auth.step,
  };
};

const Profile = connect(mapSateToProps)(UserProfile);

export default Profile;
